/**
 * Story metadata display - epic, assignee
 * Story 199: View story details with PRD and design
 */

import type { StoryDetail } from '../../hooks/useStory';
import './StoryMetadata.css';

interface StoryMetadataProps {
  story: StoryDetail;
}

export function StoryMetadata({ story }: StoryMetadataProps) {
  // Only render if there's an assignee to show (epic moved to header)
  if (!story.assignee) {
    return null;
  }

  return (
    <div className="story-metadata">
      <div className="story-metadata__row">
        <div className="story-metadata__item">
          <span className="story-metadata__label">Assignee</span>
          <span className="story-metadata__value">@{story.assignee}</span>
        </div>
      </div>
    </div>
  );
}
